import { Dispatch } from 'redux';
import { AxiosResponse } from 'axios';
import { DispatchFunction, IAppLibrary, IActiveFilter, ICatalogApplication, IWorkflowApplication, ICertificate } from '@app/models';
import {
    GET_ALL_APP_LIBRARY,
    GET_ALL_APP_LIBRARY_LOADING,
    SET_APP_LIBRARY_COUNT,
    GET_APP,
    ADD_APP_FINISHED,
    SET_APPLICATION_CERTIFICATE,
    GET_GROUPS_APP_DETAIL
} from '@app/store/constants';
import { appLibraryService } from '@app/services';
import { loadingData } from '@app/store/actions';

export function handleGetAppsData(
    orderBy: string,
    asc: string,
    top: number,
    skip: number,
    organizationId: string,
    isReset: boolean,
    filters?: IActiveFilter[]
): DispatchFunction {
    return ((dispatch: Dispatch) => {
        if (isReset) {
            dispatch(loadingData(true));
            dispatch(setAppLibraryCount(0));
            dispatch(getAllApps([]));
        }

        appLibraryService.getApps(orderBy, asc, top, skip, organizationId, isReset, filters)
            .then((response: AxiosResponse) => {
                dispatch(getAllApps(response.data.value));

                if (isReset) {
                    dispatch(setAppLibraryCount(response.data['@odata.count']));
                    dispatch(loadingData(false));
                }
            })
            .catch((error) => {
                dispatch(loadingData(false));
            });
    });
}

export function handleGetApplication(appId: string): DispatchFunction {
    return ((dispatch: Dispatch) => {
        dispatch(loadingData(true));
        appLibraryService
            .getApp(appId)
            .then(({data}: AxiosResponse) => {
                dispatch(getApp(data));
                dispatch(loadingData(false));
            })
            .catch((error: AxiosResponse) => { dispatch(loadingData(false)); });
    });
}

// to be implemented
// export function handleSetApplication()

export function getApp(app: ICatalogApplication | IWorkflowApplication) {
    return {
        payload: app,
        type: GET_APP
    };
}

export function getAllApps(apps: IAppLibrary[]) {
    return {
        payload: apps,
        type: GET_ALL_APP_LIBRARY
    };
}

export function getAllAppsLoading(appsLoading: boolean) {
    return {
        payload: appsLoading,
        type: GET_ALL_APP_LIBRARY_LOADING
    };
}

export function setAppLibraryCount(count: number) {
    return {
        payload: count,
        type: SET_APP_LIBRARY_COUNT
    };
}

export function addAppFinished(finished: boolean, appId: string) {
    return {
        payload: { finished: finished, appId: appId },
        type: ADD_APP_FINISHED
    };
}

export function setApplicationCertificate(cert: ICertificate) {
    return {
        payload: cert,
        type: SET_APPLICATION_CERTIFICATE
    };
}

export function getOffice365AppsDetails(appDetail: IAppLibrary[]) {
    return {
        payload: appDetail,
        type: GET_GROUPS_APP_DETAIL
    };
}